module.exports = __webpack_public_path__ + "static/media/1.91783a03.png";